export const messages = {
  en: {
    adminCar: {
      search: {
        title: 'Search Conditions',
        carNum: 'Please enter license plate number',
        parkingNum: 'Please enter parking space number'
      },
      list: {
        title: 'Community Vehicles'
      },
      table: {
        carNum: 'License Plate',
        memberCar: 'Member Vehicle',
        roomName: 'Room Number',
        leaseType: 'Plate Type',
        carType: 'Vehicle Type',
        color: 'Color',
        owner: 'Owner',
        parking: 'Parking Space',
        validDate: 'Validity Period',
        status: 'Status',
        remark: 'Remark'
      },
      leaseType: {
        temp: 'Temporary Vehicle'
      },
      parking: {
        released: 'Parking space released'
      },
      status: {
        normal: 'Normal',
        expired: 'Expired'
      },
      fetchError: 'Failed to fetch vehicle list'
    }
  },
  zh: {
    adminCar: {
      search: {
        title: '查询条件',
        carNum: '请输入车牌号',
        parkingNum: '请填写车位编号'
      },
      list: {
        title: '小区车辆'
      },
      table: {
        carNum: '车牌号',
        memberCar: '成员车辆',
        roomName: '房屋号',
        leaseType: '车牌类型',
        carType: '车辆类型',
        color: '颜色',
        owner: '业主',
        parking: '车位',
        validDate: '有效期',
        status: '状态',
        remark: '备注'
      },
      leaseType: {
        temp: '临时车'
      },
      parking: {
        released: '车位已释放'
      },
      status: {
        normal: '正常',
        expired: '到期'
      },
fetchError: '获取车辆列表失败'
    }
  },
  'zh-TW': {
    adminCar: {
      search: {
        title: '查詢條件',
        carNum: '請輸入車牌號',
        parkingNum: '請填寫車位編號'
      },
      list: {
        title: '小區車輛'
      },
      table: {
        carNum: '車牌號',
        memberCar: '成員車輛',
        roomName: '房屋號',
        leaseType: '車牌類型',
        carType: '車輛類型',
        color: '顏色',
        owner: '業主',
        parking: '車位',
        validDate: '有效期',
        status: '狀態',
        remark: '備註'
      },
      leaseType: {
        temp: '臨時車'
      },
      parking: {
        released: '車位已釋放'
      },
      status: {
        normal: '正常',
        expired: '到期'
      },
      fetchError: '獲取車輛列表失敗'
    }
  }
}